export class CreateTipoServicioRequest {
    public descripcion: string = ""
    
}